// src/components/radar-chart.ts
import {
  Chart, RadarController, RadialLinearScale, PointElement, LineElement,
  Filler, Tooltip, Legend,
} from 'chart.js';
import { DIMS, DIM_NAME } from '../constants/dimensions.js';
import type { Tally } from '../types/index.js';

Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export function drawRadar(
  canvas: HTMLCanvasElement,
  tally: Tally,
  preferred: string[],
): Chart {
  const labels = DIMS.map(d => `${DIM_NAME[d]}(${d})`);
  const values = DIMS.map(d => tally[d]);
  const max = Math.max(...values, 16);
  return new Chart(canvas, {
    type: 'radar',
    data: {
      labels,
      datasets: [{
        label: '你的得分',
        data: values,
        backgroundColor: 'rgba(212, 146, 90, 0.25)',
        borderColor: '#d4925a',
        pointBackgroundColor: DIMS.map(d =>
          preferred.includes(d) ? '#c47f44' : '#d4925a99'
        ),
        pointRadius: DIMS.map(d => preferred.includes(d) ? 6 : 4),
        borderWidth: 2,
      }],
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: { legend: { display: false } },
      scales: {
        r: {
          min: 0, max,
          ticks: { stepSize: Math.max(1, Math.floor(max / 4)) },
          pointLabels: {
            font: { size: 14 },
            color: (ctx: { index: number }) =>
              preferred.includes(DIMS[ctx.index] ?? '') ? '#c47f44' : '#8a6f4d',
          },
        },
      },
    },
  });
}
